export class ResponseError extends Error {
  constructor(messageData) {
    super(messageData.message);
    this.code = messageData.code;
  }
}
